// src/App.js
import React from 'react';
import { Provider } from 'react-redux';
import { Security } from '@okta/okta-react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Toast, ThemeProvider, mnoTheme } from 'portal-commons';
import configureStore from './store/configureStore';
import Favicon from 'react-favicon';
import './assets/styles/_app.scss';
import { S3_ASSETS_PATH } from './constants';
import AppWithRouterAccess from './AppWithRouterAccess';
import LoadingModal from './shared_elements/components/LoadingModal';
import datadog from './utils/datadog';
import { AuthContextProvider } from './contexts/auth';
import { SharedDataFetch } from '@/components';

const store = configureStore();

datadog.init();
const userJsonString = localStorage.getItem('user');
if (userJsonString) {
  const user = JSON.parse(userJsonString);
  !datadog.hasUser() && datadog.setUser(user);
}

const App = ({ oktaAuth }) => {
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    if (!originalUri) {
      window.location.replace('/');
      return;
    }
    const origin = new URL(originalUri, window.location.origin);
    const pathname =
      origin.pathname === '/'
        ? '/'
        : `/?redirectUri=${encodeURIComponent(originalUri)}`;
    window.location.replace(pathname);
  };

  const onAuthRequired = () => {
    window.location.replace('/login');
  };

  return (
    <div className="App">
      <ThemeProvider theme={mnoTheme}>
        <Favicon url={`${S3_ASSETS_PATH}/images/favicon-48x48.ico`} />
        <Provider store={store}>
          <AuthContextProvider>
            <LoadingModal />
            <Toast />
            <SharedDataFetch />
            <Router>
              <Security
                oktaAuth={oktaAuth}
                restoreOriginalUri={restoreOriginalUri}
                onAuthRequired={onAuthRequired}
              >
                <AppWithRouterAccess />
              </Security>
            </Router>
          </AuthContextProvider>
        </Provider>
      </ThemeProvider>
    </div>
  );
};
export default App;
